"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if a slider item is within the trackWrapper's borders + threshold
 * @param rect The rect object of a slider item with it's value "left" and "right"
 * @param trackWrapperBoundaryLeft x-value of the trackWrapper's left border
 * @param trackWrapperBoundaryRight x-value of the trackWrapper's right border
 * @param lazyLoadThreshold threshold that's considered
 * @param lazyLoadInterval ref-object of the lazyLoadInterval
 * @param setIsVisible setState of isVisible
 * @param setLoadedSliderItems setState of loadedSliderItems
 * @param sliderId the slider item's id
 */
var validateVisibility = function (rect, trackWrapperBoundaryLeft, trackWrapperBoundaryRight, lazyLoadThreshold, lazyLoadInterval, setIsVisible, setLoadedSliderItems, sliderId) {
    var left = rect.left, right = rect.right;
    if (left !== undefined &&
        right !== undefined &&
        right > trackWrapperBoundaryLeft - lazyLoadThreshold &&
        left < trackWrapperBoundaryRight + lazyLoadThreshold) {
        clearInterval(lazyLoadInterval.current);
        setIsVisible(true);
        // if id already in list don't add it twice
        setLoadedSliderItems(function (currentItems) { return __spreadArrays(currentItems.filter(function (id) { return id !== sliderId; }), [
            sliderId,
        ]); });
    }
};
exports.default = validateVisibility;
//# sourceMappingURL=validateVisibility.js.map